import styled from 'styled-components';
import {
  COLOR_CV_6,
  COLOR_NEUTRAL_4,
  COLOR_LINK,
  COLOR_CV_1,
} from 'constants/colors';
import { Button } from 'UI';
import { DownOutlined } from '@ant-design/icons';
import { AntdIconProps } from '@ant-design/icons/lib/components/AntdIcon';

export const MainContainer = styled.div`
  display: flex;
  padding-bottom: 1.5rem;
  width: 100%;
`;

export const DisplayOrgsButton = styled(Button)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: ${COLOR_NEUTRAL_4};
  color: ${COLOR_CV_6};
  border: 0;

  &:hover {
    background-color: ${COLOR_NEUTRAL_4};
    color: ${COLOR_CV_6};
  }

  &:active, &:focus {
    background-color: ${COLOR_CV_1};
    color: ${COLOR_CV_6};
  }

  &::after {
    display: none;
  }
`;

export const PopoverContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.375rem;
`;

export const InactiveButton = styled.button`
  background: transparent;
  font-size: 0.875rem;
  color: ${COLOR_CV_6};
  outline: none;
  border: none;
  width: 100%;
  text-align: left;
  text-decoration: underline;

  &:hover {
    background: transparent;
    color: ${COLOR_CV_6};
  }
`;

export const ActionButton = styled.button`
  background: transparent;
  font-size: 0.875rem;
  color: ${COLOR_LINK};
  outline: none;
  border: none;
  cursor: pointer;
  width: 100%;
  text-align: left;

  &:hover {
    text-decoration: underline;
    background: transparent;
    color: ${COLOR_LINK};
  }

  &.ant-btn:not([disabled]):hover {
    text-decoration: underline;
  }
`;

export const ArrowIcon = styled(DownOutlined)<AntdIconProps & {
  isActive?: boolean
}>`
  &.anticon {
    transition: transform 0.2s;
  }
  ${({ isActive = false }) => `
    ${isActive ? 'transform: rotate(180deg);' : ''}
  `}
`;
